import { z } from "zod";
import { isoDateTimeSchema } from "./time";

export const galaxyKindSchema = z.enum(["personal", "shared"]);
export type GalaxyKind = z.infer<typeof galaxyKindSchema>;

export const galaxyRoleSchema = z.enum(["owner", "editor", "viewer"]);
export type GalaxyRole = z.infer<typeof galaxyRoleSchema>;

export const galaxySchema = z.object({
  id: z.string().uuid(),
  name: z.string().trim().min(1).max(48),
  description: z.string().trim().max(280),
  kind: galaxyKindSchema,
  createdBy: z.string().uuid(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
  archivedAt: isoDateTimeSchema.nullable()
});
export type Galaxy = z.infer<typeof galaxySchema>;

export const galaxyMembershipSchema = z.object({
  id: z.string().uuid(),
  galaxyId: z.string().uuid(),
  userId: z.string().uuid(),
  role: galaxyRoleSchema,
  displayName: z.string().trim().min(1).max(32).nullable(),
  joinedAt: isoDateTimeSchema,
  leftAt: isoDateTimeSchema.nullable()
});
export type GalaxyMembership = z.infer<typeof galaxyMembershipSchema>;

export const galaxyInviteSchema = z.object({
  id: z.string().uuid(),
  galaxyId: z.string().uuid(),
  role: galaxyRoleSchema.exclude(["owner"]),
  expiresAt: isoDateTimeSchema,
  createdAt: isoDateTimeSchema
});
export type GalaxyInvite = z.infer<typeof galaxyInviteSchema>;

export const mediaTargetMemberSchema = z.object({
  mediaId: z.string().uuid(),
  galaxyId: z.string().uuid(),
  userId: z.string().uuid(),
  membershipJoinedAt: isoDateTimeSchema,
  targetedAt: isoDateTimeSchema
});
export type MediaTargetMember = z.infer<typeof mediaTargetMemberSchema>;

export const createGalaxyInputSchema = galaxySchema.pick({
  name: true,
  description: true,
  kind: true
});
export type CreateGalaxyInput = z.infer<typeof createGalaxyInputSchema>;
